<!-- =========================================================================================
  File Name: PurchaseCreate.vue
  Description: Add new Purchase
  ----------------------------------------------------------------------------------------
  Item Name: Vaagai Tecknowledge - Easy Admin
  Author: Web Team
  Author URL: http://www.vaagai.org.in/
========================================================================================== -->

<template>
	<div class="vx-row" id="purchase-create">        

		<!-- MULTIPLE COLUMNS-->
		<div class="vx-col w-full mb-base">
			<vx-card :title="$t('PurchaseCreateTitle')">

                <h4> {{ $t("PurchaseCreateDescription") }} </h4> <br>

                <router-link to="/purchase/lists"><vs-button color="primary" type="filled" > {{ $t("ListButton") }} </vs-button></router-link>
                <!-- <h4 class="text-success text-center">{{ successTxt }}</h4>
                <h4 class="text-danger text-center">{{ errorTxt }}</h4> -->
                <form @submit.prevent="submitForm">                    

                    <div class="vx-row">

                        <div class="vx-col sm:w-1/3 w-full mb-3">
                            <span class="text-primary text-sm vs-placeholder-label"> Invoice Date </span>
                             <datepicker placeholder="Invoice Date" v-model="InvoiceDate" :format="DateFormat" v-validate="'required'" :disabledDates="disabledDates" ></datepicker>
                            <span class="text-danger text-sm" v-show="errors.has('InvoiceDate')">{{ errors.first('InvoiceDate') }}</span>
                        </div>

                        <div class="vx-col sm:w-1/3 w-full mb-3">
                            <vs-input class="w-full" label-placeholder="Invoice Number" v-model="InvoiceNumber" v-validate="'required'" name="InvoiceNumber" :autofocus="true" />
                            <span class="text-danger text-sm" v-show="errors.has('InvoiceNumber')">{{ errors.first('InvoiceNumber') }}</span>
                        </div>

                        <div class="vx-col sm:w-1/3 w-full mb-3">
                            <span class="text-primary text-sm vs-placeholder-label"> Taxable </span>
                            <v-select v-model="TaxableId" name="TaxableId" :value="TaxableId" :options="TaxableIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                            <span class="text-danger text-sm" v-show="errors.has('TaxableId')">{{ errors.first('TaxableId') }}</span>
                        </div>                        
                    </div>

                    <div class="vx-row">
                        <div class="vx-col sm:w-1/3 w-full mb-3">
                            <span class="text-primary text-sm vs-placeholder-label"> Company RC </span>
                            <v-select v-model="CompanyRegistrationId" name="CompanyRegistrationId" :value="CompanyRegistrationId" :options="CompanyRegistrationIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                            <span class="text-danger text-sm" v-show="errors.has('CompanyRegistrationId')">{{ errors.first('CompanyRegistrationId') }}</span>
                        </div>

                        <div class="vx-col sm:w-1/3 w-full mb-3">
                            <span class="text-primary text-sm vs-placeholder-label"> Supplier </span>
                            <v-select v-model="PartyId" name="PartyId" :value="PartyId" :options="PartyIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
                            <span class="text-danger text-sm" v-show="errors.has('PartyId')">{{ errors.first('PartyId') }}</span>
                        </div>

                        <div class="vx-col sm:w-1/3 w-full mb-3">
                            <vs-input class="w-full" label-placeholder="Description" v-model="Description" name="Description" />
                            <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col w-full mb-3">
                            <h5> {{ $t("SupplierDetails") }} </h5>
                            {{ PartyDetailsTxt }}
                        </div>
                    </div>

                    <vs-table :data="Products">

                        <template slot="thead">
                            <vs-th> {{ $t("ProductCode") }} </vs-th>
                            <!-- <vs-th> Product Name </vs-th> -->
                            <vs-th> {{ $t("CurrentStock") }} </vs-th>
                            <vs-th> {{ $t("GST") }} </vs-th>
                            <vs-th> {{ $t("Quantity") }} </vs-th>
                            <vs-th> {{ $t("Price") }} </vs-th>                            
                            <vs-th> {{ $t("Amount") }} </vs-th>
                            <vs-th v-if="SgstFlag == 1"> {{ $t("SGST") }} </vs-th>
                            <vs-th v-if="SgstFlag == 1"> {{ $t("CGST") }} </vs-th>
                            <vs-th v-if="SgstFlag != 1"> {{ $t("IGST") }} </vs-th>
                            <vs-th v-if="CessFlag == 1"> CESS </vs-th>
                            <vs-th> {{ $t("SubTotal") }} </vs-th>
                            <vs-th>
                                <button type='button' class="btn btn-info" @click="addNewRow">
                                    <i class="fas fa-plus-circle"></i>
                                </button>
                            </vs-th>
                        </template>

                        <vs-tr v-for="(LocalProduct, k) in Products" :key="k">

                            <vs-td>
                                <!-- <vs-input class="box-size" style="--size: 100px;" placeholder="Custom Code" v-model="LocalProduct.CustomCode" v-validate="'required'" name="CustomCode" @change="checkCustomCode(k, LocalProduct)" /> -->
                                <v-select class="box-size" style="--size: 350px;" v-model="LocalProduct.ProductId" name="CustomCode" :value="CustomCode" :options="CustomCodeOptions" label="text" :reduce="option => option.value" v-validate="'required'" v-on:input="checkCustomCode(k, LocalProduct)" > </v-select>
                                <span class="text-danger text-sm" v-show="errors.has('CustomCode')">{{ errors.first('CustomCode') }}</span>
                            </vs-td>

                            <!-- <vs-td>
                                {{ LocalProduct.ProductName }}
                            </vs-td> -->

                            <vs-td>
                                {{ LocalProduct.CurrentStock }}
                            </vs-td>

                            <vs-td>
                                {{ LocalProduct.GST }}
                            </vs-td>

                            <vs-td>
                                <vs-input class="box-size" style="--size: 100px;" v-model="LocalProduct.Qty"  name="Qty" v-validate="'required|decimal:3|min_value:0.001'" v-on="calculateLineTotal(LocalProduct)" />
                                <span class="text-danger text-sm" v-show="errors.has('Qty')">{{ errors.first('Qty') }}</span>
                            </vs-td>                            

                            <vs-td>                    
                                <vs-input class="box-size" style="--size: 100px;" v-model="LocalProduct.Price"  name="Price" v-validate="'required|decimal:2|min_value:1'" v-on="calculateLineTotal(LocalProduct)" />
                                <span class="text-danger text-sm" v-show="errors.has('Price')">{{ errors.first('Price') }}</span>
                            </vs-td>

                            <vs-td>
                                {{ LocalProduct.Amount }}
                            </vs-td>

                            <vs-td v-if="SgstFlag == 1">
                                {{ LocalProduct.sgstTax }}
                            </vs-td>

                            <vs-td v-if="SgstFlag == 1">
                                {{ LocalProduct.cgstTax }}
                            </vs-td>
                            
                            <vs-td v-if="SgstFlag != 1">
                                {{ LocalProduct.igstTax }}
                            </vs-td>

                            <vs-td v-if="CessFlag == 1">
                                {{ LocalProduct.CessTax }}
                            </vs-td>

                            <vs-td>
                                {{ LocalProduct.SubTotal }}                                
                                <!-- <vs-input class="box-size" style="--size: 100px;" v-model="LocalProduct.SubTotal"  name="SubTotal" :readonly="true" />
                                <span class="text-danger text-sm" v-show="errors.has('SubTotal')">{{ errors.first('SubTotal') }}</span> -->
                            </vs-td>

                            <vs-td scope="row" class="trashIconContainer">
                                <button type='button' class="btn btn-info" @click="addNewRow">
                                    <i class="fas fa-plus-circle"></i>
                                </button>
                                <button type='button' class="btn btn-info" @click="deleteRow(k, LocalProduct)">
                                    <i class="far fa-trash-alt"></i>
                                </button>
                            </vs-td>

                        </vs-tr>

                    </vs-table>

                    <div class="vx-row">
                        <div class="vx-col sm:w-3/4 w-full mb-3 text-right">
                            <span> {{ $t("InvoiceSubTotal") }} </span>
                        </div>
                        <div class="vx-col sm:w-1/4 w-full mb-3">
                            <vs-input class="w-full" v-model="InvoiceSubTotal" v-validate="'required'" name="InvoiceSubTotal" :readonly="true" />
                            <span  class="text-danger text-sm" v-show="errors.has('InvoiceSubTotal')">{{ errors.first('InvoiceSubTotal') }}</span>
                        </div>
                    </div>

                    <div class="vx-row" v-if="SgstFlag == 1">
                        <div class="vx-col sm:w-3/4 w-full mb-3 text-right">
                            <span> {{ $t("SGST") }} </span>
                        </div>
                        <div class="vx-col sm:w-1/4 w-full mb-3">
                            <vs-input class="w-full" v-model="sgstTotal" v-validate="'required'" name="sgstTotal" :readonly="true" />
                            <span class="text-danger text-sm" v-show="errors.has('sgstTotal')">{{ errors.first('sgstTotal') }}</span>
                        </div>
                    </div>

                    <div class="vx-row" v-if="SgstFlag == 1">
                        <div class="vx-col sm:w-3/4 w-full mb-3 text-right">
                            <span> {{ $t("CGST") }} </span>
                        </div>
                        <div class="vx-col sm:w-1/4 w-full mb-3">
                            <vs-input class="w-full" v-model="cgstTotal" v-validate="'required'" name="cgstTotal" :readonly="true" />
                            <span class="text-danger text-sm" v-show="errors.has('cgstTotal')">{{ errors.first('cgstTotal') }}</span>
                        </div>
                    </div>

                    <div class="vx-row" v-if="SgstFlag != 1">
                        <div class="vx-col sm:w-3/4 w-full mb-3 text-right">
                            <span> {{ $t("IGST") }} </span>
                        </div>
                        <div class="vx-col sm:w-1/4 w-full mb-3">
                            <vs-input class="w-full" v-model="igstTotal" v-validate="'required'" name="igstTotal" :readonly="true" />
                            <span class="text-danger text-sm" v-show="errors.has('igstTotal')">{{ errors.first('igstTotal') }}</span>
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col sm:w-3/4 w-full mb-3 text-right">
                            <span> {{ $t("RoundOff") }} </span>
                        </div>
                        <div class="vx-col sm:w-1/4 w-full mb-3">
                            <vs-input class="w-full" v-model="RoundOffValue" v-validate="'required|decimal:2|min_value:0'" name="RoundOffValue" v-on="calculateTotal()" />
                            <span class="text-danger text-sm" v-show="errors.has('RoundOffValue')">{{ errors.first('RoundOffValue') }}</span>
                        </div>
                    </div>

                    <div class="vx-row" v-if="CessFlag == 1">
                        <div class="vx-col sm:w-3/4 w-full mb-3 text-right">
                            <span>CESS</span>
                        </div>
                        <div class="vx-col sm:w-1/4 w-full mb-3">
                            <vs-input class="w-full" v-model="CessTotal" v-validate="'required'" name="CessTotal" :readonly="true" />
                            <span class="text-danger text-sm" v-show="errors.has('CessTotal')">{{ errors.first('CessTotal') }}</span>
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col sm:w-3/4 w-full mb-3 text-right">
                            <span> {{ $t("InvoiceTotal") }} </span>
                        </div>
                        <div class="vx-col sm:w-1/4 w-full mb-3">
                            <vs-input class="w-full" v-model="InvoiceTotal" v-validate="'required'" name="InvoiceTotal" :readonly="true" />
                            <span class="text-danger text-sm" v-show="errors.has('InvoiceTotal')">{{ errors.first('InvoiceTotal') }}</span>
                        </div>
                    </div>

                    <div class="vx-row">
                        <div class="vx-col w-full mb-3 text-right">
                            <vs-button type="filled" @click.prevent="submitForm" class="mr-3 mb-2"> {{ $t("SubmitButton") }} </vs-button>
                            <router-link to="/purchase/lists"><vs-button color="warning" type="border" class="mb-2" > {{ $t("CancelButton") }} </vs-button></router-link>
                        </div>
                    </div>
                </form>
			</vx-card>
		</div>
	</div>
</template>

<script>

import companyConfig from '@/company_config.json'
import common from '@/views/Common.vue'
import { Validator } from 'vee-validate';
import vSelect from 'vue-select';
import Datepicker from 'vuejs-datepicker';

const dict = {    
    custom: {        
        TaxableId: { required : 'Taxable Id should not be empty', },
        InvoiceDate: { required : 'Invoice Date should not be empty', },
        InvoiceNumber: { required : 'Invoice Number should not be empty', },
        PartyId: { required : 'Supplier Id should not be empty', },
        Description: { required : 'Description should not be empty', },
    }
};

// register custom messages
Validator.localize('en', dict);

export default{
    mixins: [common],
    components: {
        'v-select': vSelect,
        Datepicker
    },
	data() {
		return {
            successTxt: '',
            errorTxt: '',

            ProductNames:[],

            CompanyId: '',
            CompanyStateId: '',            

            TaxableIdOptions : this.selectListTrueFalse(),
            CompanyRegistrationIdOptions : [],
            PartyIdOptions : [],
            CustomCodeOptions : [],

            DateFormat: "d-MMM-yyyy",
            disabledDates: {
                from: new Date(),
            },

            TaxableId : '',
            InvoiceDate : new Date(),
            InvoiceNumber : '',
            CompanyRegistrationId : '',
            PartyId : '0',
            Description : '',
            InvoiceTax: 5,
            InvoiceSubTotal: 0,
            sgstTotal: 0,
            cgstTotal: 0,
            igstTotal: 0,
            CessTotal: 0,
            RoundOffValue: 0,
            InvoiceTotal: 0,
            SgstFlag:1,
            CessFlag:0,

            Products: [],
            CustomCode: '',
            PartyDetails:[],            
            PartyDetailsTxt: '',
            PartyStateId : '',
		}
    },
    computed: {
        allProducts(){
            return this.$store.getters['product/dataList'];
        },
        allParties(){
            return this.$store.getters['allParty/dataList'];
        },
        cessRules(){
            return this.$store.getters['cessRules/dataList'];
        },
        allPurchase() {
            return this.$store.getters['purchase/dataList'];
        },
    },    
    methods: {
        simpleSuggestionList() {
            return [
            'Vue.js',
            'React.js',
            'Angular.js'
            ]
        },
        addRecordDetails() {
            // add todo in store and clear all fields in dialog
            console.log('addRecordDetails called');
            var n1=this.Products.length;
            console.log('n1='+n1);
            
            if (n1 > 0) {
                var recordObj = {
                    "TaxableId" :  this.TaxableId, 
                    "InvoiceDate" :  this.InvoiceDate, 
                    "InvoiceNumber" :  this.InvoiceNumber, 
                    "CompanyRegistrationId" : this.CompanyRegistrationId,
                    "PartyId" :  this.PartyId, 
                    "Description" :  this.Description, 
                    "Products" :  this.Products, 
                    "InvoiceSubTotal" :  this.InvoiceSubTotal, 
                    "sgstTotal" :  this.sgstTotal, 
                    "cgstTotal" :  this.cgstTotal, 
                    "igstTotal" :  this.igstTotal, 
                    "CessTotal" :  this.CessTotal, 
                    "RoundOffValue" :  this.RoundOffValue, 
                    "InvoiceTotal" :  this.InvoiceTotal, 
                };

                var server_url=companyConfig.apiURL;
                var record = {};
                record.token=this.$session.get('token');
                record.add_url=server_url+'lib/api/purchase/purchase/create';
                record.form=recordObj;
                record.list_url=server_url+'lib/api/purchase/purchase/lists';
                record.list_where={};
                console.log('record='+JSON.stringify(record));
                record.loading=this.$vs.loading;
                record.notify=this.$vs.notify;
                record.http=this.$http;            
                this.$store.dispatch('purchase/addRecordDetails', record);
                this.clearFields();
            }else {
                var message='Atleast One Product required to add Purchase';
                this.errorMessage(message);                
            }
        },
        clearFields() {
            // clear all fileds in todo
            this.TaxableId =  '';
            this.InvoiceDate =  new Date();
            this.InvoiceNumber =  '';
            this.CompanyRegistrationId = '';
            this.PartyId =  '';
            this.Description =  '';
            this.PartyDetailsTxt = '';
            this.Products =  [];
            this.InvoiceSubTotal =  0;
            this.cgstTotal =  0;
            this.sgstTotal =  0;
            this.igstTotal =  0;
            this.CessTotal =  0;
            this.RoundOffValue =  0;
            this.InvoiceTotal =  0;
        },
        submitForm() {
            this.$validator.validateAll().then(result => {
                if (result) this.addRecordDetails();
            })
        },
        checkPartyDetails() {
            console.log('checkPartyDetails called');
            var temp_code=this.PartyId;            
            console.log('temp_code='+temp_code);
            console.log('allParties='+JSON.stringify(this.allParties));
            var idx = this.allParties.map(e => e.PartyId).indexOf(temp_code);
            console.log('idx='+idx);
            if (idx >= 0) {
                
                var PartyCompanyName=this.allParties[idx]['PartyCompanyName'];
                var Address=this.allParties[idx]['Address'];
                var CityName=this.allParties[idx]['CityName'];
                var DistrictName=this.allParties[idx]['DistrictName'];
                var StateName=this.allParties[idx]['StateName'];
                var ContactNumber=this.allParties[idx]['ContactNumber'];
                var WhatsappNumber=this.allParties[idx]['WhatsappNumber'];                
                var Details=PartyCompanyName+', '+Address+', '+CityName+', '+', '+DistrictName+', '+', '+StateName+', '+ContactNumber+', '+WhatsappNumber;
                console.log('Details='+Details);
                
                var temp1_state_id=this.CompanyStateId;
                var temp2_state_id=this.allParties[idx]['StateId'];
                // var temp2_state_id = 2;
                var temp_flag=temp1_state_id != temp2_state_id ? 0 : 1;
                console.log('temp1_state_id='+temp1_state_id+', temp2_state_id='+temp2_state_id+', temp_flag='+temp_flag+' details='+JSON.stringify(this.allParties[idx]));

                this.PartyDetails = this.allParties[idx];
                // this.PartyDetailsTxt = Details+', '+JSON.stringify(this.allParties[idx]);
                this.PartyDetailsTxt = Details;                
                this.PartyStateId=temp2_state_id;
                this.SgstFlag=temp_flag;
                
            }else{
                var message='Supplier details not found';
                this.errorMessage(message);
                this.PartyId = '';
            }
            
        },
        checkCustomCode(index, LocalProduct) {
            console.log('checkCustomCode called');
            console.log('index='+index+', LocalProduct='+JSON.stringify(LocalProduct));
            var temp_code=LocalProduct.ProductId;
            console.log('temp_code='+temp_code);
            console.log('allProducts='+JSON.stringify(this.allProducts));
            // ProductCustomCode or ProductVariantId or VariantProductName
            var idx = this.allProducts.map(e => e.ProductVariantId).indexOf(temp_code);
            console.log('idx='+idx);
            if (idx >= 0) {
                // idx = 0;
                // this.PartyDetails = this.allProducts[idx];

                var ProductCustomCode = this.allProducts[idx]['ProductCustomCode'];
                var VariantProductName = this.allProducts[idx]['VariantProductName'];
                var ProductStock = this.allProducts[idx]['ProductStock'];
                var GstSlabValue = this.allProducts[idx]['GstSlabValue'];
                var GstSlabId = this.allProducts[idx]['GstSlabId'];

                // this.Products[index].ProductId = ProductVariantId;
                this.Products[index].CustomCode = ProductCustomCode;
                this.Products[index].ProductName = VariantProductName;
                this.Products[index].CurrentStock = ProductStock;
                this.Products[index].GST = GstSlabValue;
                this.Products[index].gstId = GstSlabId;
                this.Products[index].Price = 0;
                this.Products[index].Qty = 0;
                this.Products[index].Amount = 0;
                this.Products[index].Tax = 0;
                this.Products[index].sgstTax = 0;
                this.Products[index].cgstTax = 0;
                this.Products[index].igstTax = 0;
                this.Products[index].CessTax = 0;
                this.Products[index].SubTotal = 0;                
                
            }else{
                var message='Product custom code is invalid';
                this.errorMessage(message);
                this.Products[index].CustomCode = '';
                this.Products[index].ProductId = '';
                this.Products[index].ProductName = '';
                this.Products[index].CurrentStock = '';
                this.Products[index].GST = '';
                this.Products[index].gstId = '';                
                this.Products[index].Price = 0;
                this.Products[index].Qty = 0;
                this.Products[index].Amount = 0;
                this.Products[index].Tax = 0;
                this.Products[index].sgstTax = 0;
                this.Products[index].cgstTax = 0;
                this.Products[index].igstTax = 0;
                this.Products[index].CessTax = 0;
                this.Products[index].SubTotal = 0;
            }
            /*
            var idx = this.Products.indexOf(LocalProduct);
            console.log(idx, index);
            */
            
        },
        addNewRow() {
            this.Products.push({
                CustomCode: '',
                ProductId: '',
                ProductName: '',
                CurrentStock: '',
                GST: '',
                gstId: '',
                Price : 0,
                Qty : 0,
                Amount : 0,
                Tax : 0,
                sgstTax: 0,
                cgstTax: 0,
                igstTax: 0,
                CessTax: 0,
                SubTotal : 0,
            });
        },
        deleteRow(index, LocalProduct) {
            console.log('deleteRow called');
            console.log('index='+index+', LocalProduct='+JSON.stringify(LocalProduct));
            /*
            var idx = this.LocalLocalProducts.indexOf(LocalProduct);
            console.log(idx, index);
            */
            if (index > -1) {
                this.Products.splice(index, 1);
            }
            this.calculateTotal();
            
        },
        calculateTotal() {
            var roundOff=parseFloat(this.RoundOffValue);
            var subtotal, total;
            subtotal = this.Products.reduce(function (sum, product) {
                var lineTotal = parseFloat(product.Amount);
                if (!isNaN(lineTotal)) {
                    return sum + lineTotal;
                }
            }, 0);

            this.InvoiceSubTotal = subtotal.toFixed(2);

            var sgstTotal = 0, cgstTotal = 0, igstTotal = 0, cessTotal = 0;

            sgstTotal = this.Products.reduce(function (sum, product) {
                var lineTotal = parseFloat(product.sgstTax);
                if (!isNaN(lineTotal)) {
                    return sum + lineTotal;
                }
            }, 0);

            cgstTotal = this.Products.reduce(function (sum, product) {
                var lineTotal = parseFloat(product.cgstTax);
                if (!isNaN(lineTotal)) {
                    return sum + lineTotal;
                }
            }, 0);

            igstTotal = this.Products.reduce(function (sum, product) {
                var lineTotal = parseFloat(product.igstTax);
                if (!isNaN(lineTotal)) {
                    return sum + lineTotal;
                }
            }, 0);

            cessTotal = this.Products.reduce(function (sum, product) {
                var lineTotal = parseFloat(product.CessTax);
                if (!isNaN(lineTotal)) {
                    return sum + lineTotal;
                }
            }, 0);

            sgstTotal = sgstTotal.toFixed(2);
            cgstTotal = cgstTotal.toFixed(2);
            igstTotal = igstTotal.toFixed(2);
            cessTotal = cessTotal.toFixed(2);

            console.log('sgstTotal='+sgstTotal+', cgstTotal='+cgstTotal+', igstTotal='+igstTotal+', cessTotal='+cessTotal);

            this.CessFlag = cessTotal > 0 ? 1 : 0;

            this.sgstTotal = sgstTotal;
            this.cgstTotal = cgstTotal;
            this.igstTotal = igstTotal;
            this.CessTotal = cessTotal;

            total = parseFloat(subtotal)+ parseFloat(sgstTotal)+parseFloat(cgstTotal)+parseFloat(igstTotal)+parseFloat(cessTotal)+parseFloat(roundOff);
            total = parseFloat(total).toFixed(2);            

            if (!isNaN(total)) {
                this.InvoiceTotal = total;
            } else {
                this.InvoiceTotal = '0.00'
            }
        },
        calculateLineTotal(LocalProduct) {
            var taxId=this.TaxableId;
            console.log('calculateLineTotal called TaxableId='+taxId);
            var tax=0, sgst=0, cgst=0, igst=0, cess=0, subtotal=0;
            var sgstFlag=this.SgstFlag;
            var price=LocalProduct.Price;
            var Qty=LocalProduct.Qty;
            var amount = parseFloat(price) * parseFloat(Qty);
            if (taxId == 1) {
                tax = amount * (parseFloat(LocalProduct.GST)/100);
                if (sgstFlag == 1) {
                    sgst=tax/2;
                    cgst=tax/2;
                }else{
                    igst=tax;
                }
                var productId=LocalProduct.ProductId;
                var idx = this.cessRules.map(e => e.CessRulesProductId).indexOf(productId);
                console.log('productId='+productId+', idx='+idx);
                if (idx >= 0) {

                    console.log('cessRules='+JSON.stringify(this.cessRules[idx]));

                    var cessPercentage=this.cessRules[idx]['CessRulesPercentage'];
                    var perQty=this.cessRules[idx]['CessRulesPerQty'];
                    var fixedValue=this.cessRules[idx]['CessRulesFixedValue'];
                    var highestFlag=this.cessRules[idx]['CessRulesHighestFlag'];
                    console.log('cessPercentage='+cessPercentage+', perQty='+perQty+', fixedValue='+fixedValue+', highestFlag='+highestFlag);

                    var cessTotalPercentage=parseFloat(amount) * (parseFloat(cessPercentage) / 100);
                    var cessTotalFixedAmount=parseFloat(fixedValue) * (parseFloat(Qty) / parseFloat(perQty));
                    var cessTotal=cessTotalPercentage+cessTotalFixedAmount;
                    var cessHighest=cessTotalPercentage > cessTotalFixedAmount ? cessTotalPercentage : cessTotalFixedAmount;
                    console.log('cessTotalPercentage='+cessTotalPercentage+', cessTotalFixedAmount='+cessTotalFixedAmount+', cessTotal='+cessTotal+', cessHighest='+cessHighest);
                    cess = highestFlag == 1 ? cessHighest : cessTotal;
                }                
            }
            cess=parseFloat(cess).toFixed(2);
            subtotal = parseFloat(amount)+parseFloat(sgst)+parseFloat(cgst)+parseFloat(igst)+parseFloat(cess);
            subtotal=subtotal.toFixed(2);
            if (!isNaN(amount) && !isNaN(tax) && !isNaN(subtotal)) {
                LocalProduct.Amount = amount;
                LocalProduct.Tax = tax;
                LocalProduct.sgstTax = sgst;
                LocalProduct.cgstTax = cgst;
                LocalProduct.igstTax = igst;
                LocalProduct.CessTax = cess;
                LocalProduct.SubTotal = subtotal;
            }
            this.calculateTotal();
        },
        loadProducts(){

            // Load Products

            var getAllRecords={};
            var server_url=companyConfig.apiURL;

            getAllRecords.token=this.$session.get('token');
            getAllRecords.list_url=server_url+'lib/api/product/product/lists';
            getAllRecords.list_where={};
            console.log('beforeMount getAllRecords='+JSON.stringify(getAllRecords));
            getAllRecords.loading=this.$vs.loading;
            getAllRecords.notify=this.$vs.notify;
            getAllRecords.http=this.$http;    
            this.$store.dispatch('product/loadAllRecords', getAllRecords);            
        }
    },
    beforeCreate: function () {    
        if (!this.$session.exists()) {
            console.log('your session is expired');
            this.$router.push('/');
        }
    },
    beforeMount() {
        if (!this.$session.exists()) {
            console.log('your session is expired');
            this.$router.push('/');      
        }else{

            const token=this.$session.get('token');
            const username=this.$session.get('username');
            const role=this.$session.get('role');
            const CompanyId=this.$session.get('CompanyId');
            const CompanyStateId=this.$session.get('CompanyStateId');
            console.log('token='+token+', username='+username+', role='+role+', CompanyId='+CompanyId+', CompanyStateId='+CompanyStateId);

            this.CompanyId = CompanyId;
            this.CompanyStateId = CompanyStateId;

            var server_url=companyConfig.apiURL;

            // Load Suppliers

            var getAllRecords={};

            getAllRecords.token=this.$session.get('token');
            getAllRecords.list_url=server_url+'lib/api/party/party/lists';
            getAllRecords.list_where={
                "party_details_party_category_id >=" : 1
            };
            console.log('beforeMount getAllRecords='+JSON.stringify(getAllRecords));
            getAllRecords.loading=this.$vs.loading;
            getAllRecords.notify=this.$vs.notify;
            getAllRecords.http=this.$http;
            this.$store.dispatch('allParty/loadAllRecords', getAllRecords);

            // Load CESS Rules

            getAllRecords={};
            getAllRecords.token=this.$session.get('token');
            getAllRecords.list_url=server_url+'lib/api/product/cess/lists';
            getAllRecords.list_where={
                "cess_rules_id >=" : 1
            };
            console.log('beforeMount getAllRecords='+JSON.stringify(getAllRecords));
            getAllRecords.loading=this.$vs.loading;
            getAllRecords.notify=this.$vs.notify;
            getAllRecords.http=this.$http;
            this.$store.dispatch('cessRules/loadAllRecords', getAllRecords);
            
            // Load Purchase

            getAllRecords={};
            getAllRecords.token=this.$session.get('token');
            getAllRecords.list_url=server_url+'lib/api/purchase/purchase/lists';
            getAllRecords.list_where={};
            console.log('beforeMount getAllRecords='+JSON.stringify(getAllRecords));
            getAllRecords.loading=this.$vs.loading;
            getAllRecords.notify=this.$vs.notify;
            getAllRecords.http=this.$http;    
            this.$store.dispatch('purchase/loadAllRecords', getAllRecords);

            // Load Suppliers Dropdown

            var selectbox1_source = 'PartyId'
            var selectbox1_destination = 'PartyIdOptions'
            var selectbox1_url = 'lib/api/data/get_supplier_options'
            var selectbox1_conditions_array = {
                'PartyCategoryId':1,
                'where': {
                    'party_details_party_category_id <=': 2
                }
            }
            this.getSelectBoxOptions(selectbox1_source, selectbox1_destination, selectbox1_conditions_array, selectbox1_url);
            
            var selectbox3_source = 'CustomCode'
            var selectbox3_destination = 'CustomCodeOptions'
            var selectbox3_url = 'lib/api/data/get_product_variant_options'
            var selectbox3_conditions_array = {
                'AllProducts': 0,
                'where': {
                    'product_company_relation_id >=': 1
                }
            }
            this.getSelectBoxOptions(selectbox3_source, selectbox3_destination, selectbox3_conditions_array, selectbox3_url);

            // Load Company Registration Dropdown

            var selectbox2_source = 'CompanyRegistrationId'
            var selectbox2_destination = 'CompanyRegistrationIdOptions'
            var selectbox2_url = 'lib/api/data/get_company_registration_options'
            var selectbox2_conditions_array = {
                'where': {},
                'or_where': {}
            }
            this.getSelectBoxOptions(selectbox2_source, selectbox2_destination, selectbox2_conditions_array, selectbox2_url);

            // Load Products

            this.loadProducts();
        }
    },
    watch: {
        PartyIdOptions: function(){
            console.log('watch PartyIdOptions='+JSON.stringify(this.PartyIdOptions));
            var n1=this.PartyIdOptions.length;
            console.log('n1='+n1);
            if (n1 > 0) {
                var temp=this.PartyIdOptions[0];
                console.log('temp='+JSON.stringify(temp));
                var str1=this.PartyId;                
                var str2=str1.toString();
                var index = this.PartyIdOptions.map(e => e.value).indexOf(str1);
                console.log('str1='+str1+', str2='+str2+', index='+index);
                this.PartyId=index > 0 ? str2 : "";
            }
        },
        CustomCodeOptions: function(){
            console.log('watch CustomCodeOptions='+JSON.stringify(this.CustomCodeOptions));
            var n1=this.CustomCodeOptions.length;
            console.log('n1='+n1);
            if (n1 > 0) {
                var temp=this.CustomCodeOptions[0];
                console.log('temp='+JSON.stringify(temp));
                var str1=this.CustomCode;                
                var str2=str1.toString();
                var index = this.CustomCodeOptions.map(e => e.value).indexOf(str1);
                console.log('str1='+str1+', str2='+str2+', index='+index);
                this.CustomCode=index > 0 ? str2 : "";
            }
        },                
        PartyId: function(){
            var temp=this.PartyId;
            console.log('watch PartyId='+temp);
            if (temp != "") {
                this.checkPartyDetails();                
            }            
        },
        allPurchase: function () {
            console.log('watch allPurchase');
            this.loadProducts();
        },
        /*
        allProducts: function(){
            console.log('watch allProducts');
            var n1=this.allProducts.length;
            console.log('n1='+n1);
            if (n1 > 0) {
                var tempProducts1 = this.allProducts.filter(function(product) {
                    return product.ProductCustomCode != "";
                });
                var n2=tempProducts1.length;
                console.log('n2='+n2);
                console.log('tempProducts1='+JSON.stringify(tempProducts1));
                if (n2 > 0) {
                    var tempProducts2 = tempProducts1.map(function (product) {
                        return product.ProductCustomCode;
                    });
                    var n3=tempProducts2.length;
                    console.log('n3='+n3);
                    console.log('tempProducts2='+JSON.stringify(tempProducts2));
                    this.ProductNames = n3 > 0 ? tempProducts2 : [];
                }
            }
        },
        */
    }
}
</script>

<style lang="scss">

#purchase-create {
    .vs-con-table .vs-con-tbody {
        z-index: 1;
        overflow: visible;
    }
    .vs-con-table {
        overflow: visible;
    }
    .vs-table--content{
        overflow: visible;
    }
}
.box-size{
    width: var(--size);
}

</style>